import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './contexts/AuthContext';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Users from './pages/Users';
import Usage from './pages/Usage';
import Errors from './pages/Errors';
import Models from './pages/Models';
import Monitoring from './pages/Monitoring';
import Memory from './pages/Memory';
import Intelligence from './pages/Intelligence';
import ConversationSummaries from './pages/ConversationSummaries';
import MetricsDashboard from './pages/MetricsDashboard';
import Settings from './pages/Settings';
import TokenBudgets from './pages/TokenBudgets';
import ConsensusConfig from './pages/ConsensusConfig';
import SubscriptionPlans from './pages/SubscriptionPlans';
import CouncilConfig from './pages/CouncilConfig';
import './App.css';

function PrivateRoute({ children }) {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="loading-screen">
        <div className="spinner"></div>
        <span>Loading...</span>
      </div>
    );
  }

  return isAuthenticated ? children : <Navigate to="/login" />;
}

function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="/*"
        element={
          <PrivateRoute>
            <Layout>
              <Routes>
                <Route path="/" element={<Dashboard />} />
                <Route path="/users" element={<Users />} />
                <Route path="/usage" element={<Usage />} />
                <Route path="/errors" element={<Errors />} />
                <Route path="/models" element={<Models />} />
                <Route path="/monitoring" element={<Monitoring />} />
                <Route path="/memory" element={<Memory />} />
                <Route path="/intelligence" element={<Intelligence />} />
                <Route path="/conversation-summaries" element={<ConversationSummaries />} />
                <Route path="/metrics" element={<MetricsDashboard />} />
                <Route path="/token-budgets" element={<TokenBudgets />} />
                <Route path="/consensus" element={<ConsensusConfig />} />
                <Route path="/subscriptions" element={<SubscriptionPlans />} />
                <Route path="/council" element={<CouncilConfig />} />
                <Route path="/settings" element={<Settings />} />
              </Routes>
            </Layout>
          </PrivateRoute>
        }
      />
    </Routes>
  );
}

export default App;
